import React from 'react';

import { BoulderColors } from 'src/util/brand';

export const CardDivider = () => {
  return <div style={{ borderBottom: `1px solid ${BoulderColors.Gray3}`, margin: '16px 0' }} />;
};
